var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"tabActive":1}}),_c('Scroll'),_c('ProductBlock'),_c('UseBlock'),_c('About'),_c('ContactUs'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }